import {useSelector} from "react-redux";
import moment from "moment";
import {useMemo} from "react";

function useDefaultWeek(startOfTermDate) {

    const currentWeekNumber = useSelector(state => state.schedule.currentWeekNumber);

    return useMemo(() => {
        let week = currentWeekNumber;

        if (startOfTermDate) {
            const date = moment();

            const startOfTermAsStartOfWeek = moment(startOfTermDate).isoWeekday(1);
            while (date.isBefore(startOfTermAsStartOfWeek, 'day')) {
                date.add(7, 'days');
                week++;
            }
            const today = moment();
            if (!today.isBefore(startOfTermAsStartOfWeek, 'day') && today.isoWeekday() === 7) {
                week++;
            }
            const remainder = week % 4;
            week = remainder === 0 ? 4 : remainder;
        }
        return week;
    }, [currentWeekNumber, startOfTermDate]);
}

export default useDefaultWeek;